import { Brain, GraduationCap, Sparkles } from "lucide-react";
import { ROUTES } from "@/constants/routes";
import type { Service } from "@/types/models";

export const services: Service[] = [
  {
    icon: Brain,
    title: "Hipnoterapia",
    description:
      "Sessões personalizadas para apoiar na gestão da ansiedade, fobias, gaguez e hábitos indesejados — através de uma abordagem breve focada nos objetivos previamente definidos.",
    link: ROUTES.hipnoterapia,
    color: "bg-oceanBlue/10 text-oceanBlue",
  },
  {
    icon: GraduationCap,
    title: "Formação",
    description:
      "Workshops de relaxamento, mindfulness, gestão do stress, educação positiva e hipnose, adaptados a diferentes públicos e necessidades.",
    link: ROUTES.formacao,
    color: "bg-gold/10 text-gold",
  },
  {
    icon: Sparkles,
    title: "Super aprendizagem",
    description:
      "Programa especializado para alunos do 5.º ao 12.º ano — focado no relaxamento, memorização e programação neurolinguística — para potenciar o desempenho escolar.",
    link: ROUTES.superAprendizagem,
    color: "bg-rose/10 text-rose",
  },
];
